function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { t } from '../i18n';
import SvgIcon from './SvgIcon';
var defaultProps = {
  className: '',
  viewBox: '0 0 16 16'
};

function InfoCircleIconThin(props) {
  var iconCssClasses = "ds-c-icon--info-circle-thin ".concat(props.className || '');
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: t('icons.infoCircle')
  }, defaultProps, props, {
    className: iconCssClasses
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm1-3.7V6.4H7v5.9h2zM7 4.9c0 .6.3.9 1 .9s1-.3 1-.9c0-.3-.1-.5-.2-.7-.2-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.1.2-.2.4-.2.7z",
    fillRule: "nonzero"
  }));
}

export default InfoCircleIconThin;